// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ReactSelectCommonLayout} from 'app_components/commons/reactSelect'
import { GroupTypeBase, OptionTypeBase, SelectComponentsConfig } from 'react-select'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface IReactSelectCommonProps {
  components?: SelectComponentsConfig<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>
  identifier?: string
  options: Array<any>
  formHooks?: any
  title?: string
  label?: string
  defaultValue?: Array<any>
  isMulti: boolean
  formatCreateLabel?: (inputValue: string) => React.ReactNode
  onChangeSelect?: any
  required?: boolean
  className?: string
  isCreatable?: boolean
  placeholder?: string
  isDisabled?: boolean
  disableClear?: boolean
}
interface IReactSelectCommonState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ReactSelectCommon extends Component<IReactSelectCommonProps, IReactSelectCommonState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IReactSelectCommonProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <ReactSelectCommonLayout
        {...this.props}
      />
    )
  }
}

export default connect(mapStatesToProps)(ReactSelectCommon)
